import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EmvioSelect } from '@nexio/emvio-form-components';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import { getMerchants, getIsMerchantsLoading, getIsMerchantsLoaded } from '../Merchants/merchantsEntity';
import { getSelectedMerchants } from '../MerchantSelector/merchantSelectorViewState';
import { updateSelectedMerchants } from '../MerchantSelector/merchantSelectorActions';
import './InPageMerchantSelector.scss';
import _ from 'lodash';

export class InPageMerchantSelector extends Component {
    static propTypes = {
        merchants: PropTypes.array,
        selectedMerchants: PropTypes.array,
        isLoading: PropTypes.bool,
        isMerchantsLoaded: PropTypes.bool,
        onUpdateSelectedMerchants: PropTypes.func.isRequired,
        label: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
        merchants: [],
        selectedMerchants: [],
        isLoading: false,
        isMerchantsLoaded: false,
        className: ''
    };

    componentDidUpdate(prevProps) {
        // When merchants are loaded and no selection exists, select the first merchant
        if (!prevProps.isMerchantsLoaded && this.props.isMerchantsLoaded) {
            const { selectedMerchants, merchants, onUpdateSelectedMerchants } = this.props;

            if ((!selectedMerchants || selectedMerchants.length === 0) && merchants && merchants.length > 0) {
                // No selection exists, default to first merchant
                onUpdateSelectedMerchants([merchants[0]], false);
            }
        }
    }

    renderMerchantLabel = (merchant) => {
        let label = `${_.get(merchant, 'name', '')} - ${_.get(merchant, 'merchantId', '')}`;

        return label;
    };

    getMerchantOptions = () => {
        const { merchants } = this.props;

        if (!merchants || merchants.length === 0) {
            return [];
        }

        let options = merchants.map((merchant) => ({
            value: merchant.merchantId,
            label: this.renderMerchantLabel(merchant)
        }));

        return options;
    };

    getSelectedOption = () => {
        const { selectedMerchants, merchants } = this.props;

        // If there are selected merchants from the multiselect, use the first one
        if (selectedMerchants && selectedMerchants.length > 0) {
            const selectedMerchant = selectedMerchants[0];

            if (selectedMerchant) {
                return {
                    value: selectedMerchant.merchantId,
                    label: this.renderMerchantLabel(selectedMerchant)
                };
            }
        }

        // Default to first merchant if available
        if (merchants && merchants.length > 0) {
            return {
                value: merchants[0].merchantId,
                label: this.renderMerchantLabel(merchants[0])
            };
        }

        return null;
    };

    handleMerchantChange = (selectedOption) => {
        const { merchants, onUpdateSelectedMerchants } = this.props;

        // Handle case where selectedOption could be the value directly or an object
        let merchantId;
        if (selectedOption) {
            if (typeof selectedOption === 'object' && selectedOption.value !== undefined) {
                merchantId = selectedOption.value;
            } else if (typeof selectedOption === 'string' || typeof selectedOption === 'number') {
                merchantId = selectedOption;
            }
        }

        if (!merchantId) {
            if (merchants && merchants.length > 0) {
                onUpdateSelectedMerchants([merchants[0]], false);
            }

            return;
        }

        // Find the full merchant object
        const selectedMerchant = merchants.find(
            (merchant) => merchant.merchantId === merchantId
        );

        if (selectedMerchant) {
            // Update with single merchant selection
            onUpdateSelectedMerchants([selectedMerchant], false);
        }
    };

    render() {
        const { isLoading, className } = this.props;
        const options = this.getMerchantOptions();
        const selectedOption = this.getSelectedOption();
        const selectKey = `merchant-${selectedOption?.value || 'none'}`;

        return (
            <div className="in-page-merchant-selector">
                <div className="inline-merchant-selector-label">
                    Merchant Selector
                </div>
                <div className={`inline-merchant-selector ${className}`}>
                    <div className="inline-merchant-selector-dropdown">
                        {isLoading ? (
                            <div className="inline-merchant-selector-loading">
                                <LoadingSpinner size="small" relative />
                            </div>
                        ) : (
                            <EmvioSelect
                                key={selectKey}
                                className="in-page-merchant-selector-select"
                                id="merchantSelector"
                                name="merchantSelector"
                                options={options}
                                defaultSelectedOption={selectedOption}
                                onChange={this.handleMerchantChange}
                                placeholder="Select a merchant"
                                isSearchable={true}
                                value={selectedOption}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchants: getMerchants(state),
        selectedMerchants: getSelectedMerchants(state),
        isLoading: getIsMerchantsLoading(state),
        isMerchantsLoaded: getIsMerchantsLoaded(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onUpdateSelectedMerchants: (merchants, isAllSelected) =>
            dispatch(updateSelectedMerchants(merchants, isAllSelected))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InPageMerchantSelector);

